import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import AlignmentBox from './children/AlignmentBox';
import ButtonsList from './children/ButtonsList';
import ButtonsDesing from './children/ButtonsDesign';
import Tabs from '../../../../Tabs';
import SizeBox from '../../../Shared/SizeBox';
import MarginBox from '../../../Shared/MarginBox';
import CustomTabs from '../../../Shared/CustomTabs';

const MainDiv = styled.div`
  display: flex;
  flex-direction: column;
  height: 82vh;
  background-color: white;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 10px 10px 20px 20px;
  // margin-left: -24px;
  margin-left: -29px;
  margin-top: -10px;
  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`;

function Settings({
  fullWidth,
  handleWidthChange,
  handleMarginChange,
  margin,
  isApplyMarginOnAllSides,
  handleMarginCheckBox = () => {},
  allSideMargin,
  handleSliderMarginChange = () => {},

  // Buttons
  selectedAlignment,
  handleAlignmentChange,
  allButtons,
  handleChangeButtonsList,
}) {
  const handleAdjustment = (type, side, operation) => {
    if (type === 'margin') {
      const newValue = operation === 'increase' ? margin[side] + 1 : margin[side] - 1;
      if (newValue >= 0) handleMarginChange(side, newValue);
    }
  };

  const mainTabs = ['Buttons', 'Layout', 'List'];
  const [selectedMainTab, setSelectedMainTab] = useState(mainTabs[1]);

  const renderLayout = () => {
    return (
      <MainDiv>
        <SizeBox fullWidth={fullWidth} handleWidthChange={handleWidthChange} />
        <AlignmentBox
          isActive={!fullWidth}
          selectedAlignment={selectedAlignment}
          handleAlignmentChange={handleAlignmentChange}
        />
        <MarginBox
          onlyVerticalMargins={false}
          margin={margin}
          increaseMargin={(side) => handleAdjustment('margin', side, 'increase')}
          decreaseMargin={(side) => handleAdjustment('margin', side, 'decrease')}
          isApplyMarginOnAllSides={isApplyMarginOnAllSides}
          handleMarginCheckBox={handleMarginCheckBox}
          allSideMargin={allSideMargin}
          handleSliderMarginChange={handleSliderMarginChange}
          fullWidth={fullWidth}
          handleMarginChange={handleMarginChange}
        />
      </MainDiv>
    );
  };

  const renderButtonsList = () => {
    return (
      <div>
        <ButtonsList handleChangeButtonsList={handleChangeButtonsList} allButtons={allButtons} />
      </div>
    );
  };

  const renderButtonsDesing = () => {
    return (
      <div>
        <ButtonsDesing handleChangeButtonsList={handleChangeButtonsList} allButtons={allButtons} />
      </div>
    );
  };

  const tabOptions = new Map([
    ['0', { label: 'Button', component: renderButtonsDesing() }],
    ['1', { label: 'Layout', component: renderLayout() }],
    ['2', { label: 'List', component: renderButtonsList() }],
  ]);

  const [selectedTab, setSelectedTab] = useState('0');

  const handleTabChange = (e, newVal) => {
    setSelectedTab(newVal);
  };

  return (
    <div>
      <CustomTabs
        selectedTab={selectedTab}
        handleTabChange={handleTabChange}
        options={tabOptions}
      />
    </div>
  );
}

export default Settings;
